'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ../~/react/react.js
// module id = 71
// module chunks = 0